var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#33233d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.23)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    rx: 10,
    transform: "translate(0.23)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.082 6.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.527,5.838a4.681,4.681,0,1,0,4.681,4.681,4.681,4.681,0,0,0-4.681-4.681Zm0,7.72a3.038,3.038,0,1,1,3.038-3.038A3.038,3.038,0,0,1,10.527,13.558Z",
    transform: "translate(-1.402 -1.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.884.058c-1.679-.078-5.836-.074-7.516,0A5.452,5.452,0,0,0,1.539,1.533C-.215,3.288.009,5.652.009,9.119c0,3.549-.2,5.858,1.53,7.586,1.761,1.761,4.16,1.53,7.586,1.53,3.515,0,4.728,0,5.971-.479,1.69-.656,2.966-2.167,3.09-4.88.079-1.679.074-5.836,0-7.516-.151-3.2-1.869-5.145-5.3-5.3Zm2.657,15.487c-1.15,1.15-2.746,1.048-6.437,1.048-3.8,0-5.325.056-6.437-1.059-1.281-1.275-1.049-3.322-1.049-6.426,0-4.2-.431-7.225,3.784-7.441.968-.034,1.254-.046,3.692-.046l.034.023c4.051,0,7.229-.424,7.42,3.79.043.962.053,1.251.053,3.685,0,3.757.071,5.29-1.06,6.426Z",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.094,
    cy: 1.094,
    r: 1.094,
    transform: "translate(12.898 3.159)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a98ef6a04f5d4ff79164c5a77e7eb3f7.svg";
export { ForwardRef as ReactComponent };